<template>
  <div>
    <div style="text-align: right;">
      <span class="ant-descriptions-title" style="float: left;">
        History Annual Leave
      </span>

      <a-button type="link" icon="plus" @click="visible = true"></a-button>
    </div>
    <a-table
      size="small"
      :loading="loading"
      :columns="columns"
      :data-source="annualLeaveYears"
      :pagination="false"
      rowKey="id"
    >
      <div slot="used" slot-scope="text, record">
        {{ (text / +record.totalWorkingHoursPerDay) | numParseFloat(2) }}
      </div>
      <div slot="unused" slot-scope="text, record">
        {{ (text / +record.totalWorkingHoursPerDay) | numParseFloat(2) }}
      </div>
      <div slot="total" slot-scope="text, record">
        {{ (text / +record.totalWorkingHoursPerDay) | numParseFloat(2) }}
      </div>
      <div slot="action" slot-scope="text, record">
        <a-button
          type="link"
          icon="edit"
          @click="openDrawer(record)"
        ></a-button>
      </div>
    </a-table>
    <a-drawer
      :width="450"
      title="History annual leave"
      placement="right"
      :visible="visible"
      v-if="visible"
      @close="openDrawer()"
      :bodyStyle="{ overflowY: 'auto', maxHeight: 'calc(100% - 100px)' }"
    >
      <AnnualLeaveYearEdit
        v-if="annualLeaveYearEdit.id"
        :annualLeaveYear="annualLeaveYearEdit"
        :employee="employee"
        :refreshAfterUpdated="refreshAfterUpdated"
        :refreshAfterDeleted="refreshAfterDeleted"
        :close="openDrawer"
      />

      <AnnualLeaveYearAdd
        v-else
        :employee="employee"
        :refreshAfterCreated="refreshAfterCreated"
        :close="openDrawer"
        :annualLeaveYears="annualLeaveYears"
      />
    </a-drawer>
  </div>
</template>
<script>
import queryAnnualLeaveYear from "../../Constants/queryAnnualLeaveYear";
import AnnualLeaveYearAdd from "./AnnualLeaveYearAdd";
import AnnualLeaveYearEdit from "./AnnualLeaveYearEdit";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";

const columns = [
  {
    dataIndex: "year",
    key: "year",
    title: "Year",
    align: "center",
  },
  {
    title: "Total annual leave",
    dataIndex: "total",
    key: "total",
    align: "center",
    scopedSlots: { customRender: "total" },
  },
  {
    title: "Unused",
    dataIndex: "unused",
    key: "unused",
    align: "center",
    scopedSlots: { customRender: "unused" },
  },
  {
    title: "Used",
    key: "used",
    dataIndex: "used",
    align: "center",
    scopedSlots: { customRender: "used" },
  },
  {
    title: "",
    key: "action",
    scopedSlots: { customRender: "action" },
    align: "center",
  },
];

export default {
  components: { AnnualLeaveYearAdd, AnnualLeaveYearEdit },
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      columns,
      annualLeaveYears: [],
      loading: false,
      visible: false,
      annualLeaveYearEdit: {},
    };
  },
  computed: {
    workShift() {
      return (
        this.employee.workShift || this.employee?.branchLocation?.mainShift
      );
    },
  },
  created() {
    this.onGetAllEmployeeAnnualLeaveYear();
  },
  methods: {
    onGetAllEmployeeAnnualLeaveYear() {
      this.loading = true;
      this.$apollo
        .query({
          query: queryAnnualLeaveYear.getAllEmployeeAnnualLeaveYear,
          variables: {
            employeeIds: [this.employee.id],
          },
          fetchPolicy: "no-cache",
        })
        .then(({ data }) => {
          if (data?.getAllEmployeeAnnualLeaveYear?.length >= 0) {
            this.annualLeaveYears = [...data.getAllEmployeeAnnualLeaveYear];
          }
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          console.error("Lỗi không lấy được danh sách");
        });
    },
    openDrawer(item) {
      if (item?.id) {
        this.visible = true;
        this.annualLeaveYearEdit = { ...item };
      } else {
        this.visible = false;
        this.annualLeaveYearEdit = {};
      }
    },
    refreshAfterUpdated(item) {
      this.annualLeaveYears = updateForUpdated(this.annualLeaveYears, item);
    },
    refreshAfterDeleted(item) {
      this.annualLeaveYears = updateForDeleted(this.annualLeaveYears, item);
    },
    refreshAfterCreated(item) {
      this.annualLeaveYears = updateForCreated({
        list: this.annualLeaveYears,
        item,
      });
    },
  },
};
</script>
<style lang="css" scoped></style>
